module.exports = __webpack_public_path__ + "static/media/Samarth_Kanwate.5bb17c4a.jpg";